import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Capacitor } from '@capacitor/core'
import { notifyManager } from '@tanstack/react-query'
import { App } from './App'
import { registerServiceWorker } from '@/lib/register-sw'
import { initNativeUI } from '@/lib/capacitor-ui'
import { initOTAUpdates, registerOtaLifecycleListener } from '@/lib/capacitor-updater'
import { initPushNotifications } from '@/lib/push-notifications'
import './styles/reset.css'
import './styles/tokens.css'
import './styles/animations.css'
import './styles/global.css'
import '@/styles/fullcalendar-theme.css'

// Tag <html> so CSS can target native vs web
if (Capacitor.isNativePlatform()) {
  document.documentElement.classList.add('capacitor-native')

  // On iOS WKWebView, React Query notifications go through a double-scheduled
  // chain (observer update → subscriber notification). Both setTimeout(0) and
  // requestAnimationFrame can be throttled/coalesced by WKWebView on cold start
  // when there's no user interaction, causing query results to never paint until
  // a touch or rotation. queueMicrotask is immune to this — it runs at the end
  // of the current microtask queue, before WKWebView can idle the event loop.
  // React 18's automatic batching prevents excessive re-renders.
  notifyManager.setScheduler((cb) => queueMicrotask(cb))
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

registerServiceWorker()
initNativeUI()
initOTAUpdates()
registerOtaLifecycleListener()
initPushNotifications()
